module.exports = "/_next/static/images/34-1-6a64c4a84430ea8f95cd3954270a9d2e.jpg";